import type { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import AboutPage from '../pages/about/page';
import AppleServicePage from '../pages/apple-service/page';
import SamsungServicePage from '../pages/samsung-service/page';
import GooglePixelServicePage from '../pages/google-pixel-service/page';
import OnePlusServicePage from '../pages/oneplus-service/page';
import VivoServicePage from '../pages/vivo-service/page';
import RealmeServicePage from '../pages/realme-service/page';
import MotorolaServicePage from '../pages/motorola-service/page';
import { ServicesPage } from '../pages/services/page';
import ContactPage from '../pages/contact/page';
import PrivacyPolicyPage from '../pages/privacy-policy/page';
import TermsConditionsPage from '../pages/terms-conditions/page';
import { NotFound } from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/apple-service',
    element: <AppleServicePage />,
  },
  {
    path: '/samsung-service',
    element: <SamsungServicePage />,
  },
  {
    path: '/google-pixel-service',
    element: <GooglePixelServicePage />,
  },
  {
    path: '/oneplus-service',
    element: <OnePlusServicePage />,
  },
  {
    path: '/vivo-service',
    element: <VivoServicePage />,
  },
  {
    path: '/realme-service',
    element: <RealmeServicePage />,
  },
  {
    path: '/motorola-service',
    element: <MotorolaServicePage />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicyPage />,
  },
  {
    path: '/terms-conditions',
    element: <TermsConditionsPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;